module.exports = __webpack_public_path__ + "img/icon-battery.f60f177d.svg";